import UIAction from '../../actions/ui/UIAction';
import ObjectDrawingUIAction from '../../actions/ui/ObjectDrawingUIAction';
import TextboxUIAction from '../../actions/ui/TextboxUIAction';
import FreehandPenUIAction from '../../actions/ui/FreehandPenUIAction';
import ReflowableContentUIAction from '../../actions/ui/ReflowableContentUIAction';
import { ObjectDrawingState, initObjectDrawingUIState, objectDrawing } from './objectDrawing';
import { TextboxState, initTextboxUIState, textbox } from './textbox';
import { FreehandPenState, initFreehandPenUIState, freehandPen } from './freehandPen';
import {
  ReflowableContentSettingState,
  initReflowableContentSettingUIState,
  reflowableContentSetting,
} from './reflowableContentSetting';
import { MultiroleLinkKind } from '../../../../../common/src/ts/types/multiroleLink';

export const enum CurrentTool {
  MultiroleLink,
  ImagePasting,
  ObjectDrawing,
  ObjectSelection,
  ObjectRemoval,
  AllErasing,
  Textbox,
  Touch, // 紙面操作(テキスト選択) + ズーム/パン
  Mouse, // 紙面操作(テキスト選択)
  RegionZoom,
  FreeHandPen,
  Handerasing,
  LearningPen,
  MarkerAppend,
  MarkerDelete,
}

export interface MultiroleLinkState {
  mode: MultiroleLinkKind;
  [MultiroleLinkKind.File]: {
    path: string;
    title: string;
    pinColor: string; // Color
  };
  [MultiroleLinkKind.Web]: {
    url: string;
    title: string;
    pinColor: string; // Color
  };
  [MultiroleLinkKind.Page]: {
    pageKey: string; // ページ番号？cfi？
    title: string;
    pinColor: string; // Color
  };
}

export const enum LineStyle {
  Freehand,
  HorizontalAxisAligned,
  VerticalAxisAligned,
}

interface HanderasingState {
  width: number;
}

interface LearningPenState {
  widthIndex: number;
}

interface MarkerState {
  selectedColorIndex: number;
}

interface GeneralRubyState {
  enabled: boolean;
}

const enum VoiceType {
  TypeA, // STUB
  TypeB, // STUB
}

interface TTSSettingState {
  speed: number;
  voiceType: VoiceType;
}

export interface UIState {
  currentTool: CurrentTool;
  multiroleLink: MultiroleLinkState;
  objectDrawing: ObjectDrawingState;
  textbox: TextboxState;
  freehandPen: FreehandPenState;
  handerasing: HanderasingState;
  learningPen: LearningPenState;
  marker: MarkerState;
  generalRuby: GeneralRubyState;
  reflowableContentSetting: ReflowableContentSettingState;
  ttsSetting: TTSSettingState;
}

export function initUIState(): UIState {
  return {
    currentTool: CurrentTool.Touch,
    multiroleLink: {
      mode: MultiroleLinkKind.File,
      [MultiroleLinkKind.File]: {
        path: '',
        title: '',
        pinColor: '1',
      },
      [MultiroleLinkKind.Web]: {
        url: '',
        title: '',
        pinColor: '1',
      },
      [MultiroleLinkKind.Page]: {
        pageKey: '',
        title: '',
        pinColor: '1',
      },
    },
    objectDrawing: initObjectDrawingUIState(),
    textbox: initTextboxUIState(),
    freehandPen: initFreehandPenUIState(),
    handerasing: { width: 40 },
    learningPen: { widthIndex: 3 },
    marker: { selectedColorIndex: 0 },
    generalRuby: { enabled: false },
    reflowableContentSetting: initReflowableContentSettingUIState(),
    ttsSetting: {
      speed: 1,
      voiceType: VoiceType.TypeA,
    },
  };
}

export const ui = (state: UIState, action: UIAction.Action): UIState => {
  if (ObjectDrawingUIAction.isDomesticAction(action)) {
    return { ...state, objectDrawing: objectDrawing(state.objectDrawing, action) };
  }

  if (TextboxUIAction.isDomesticAction(action)) {
    return { ...state, textbox: textbox(state.textbox, action) };
  }

  if (FreehandPenUIAction.isDomesticAction(action)) {
    return { ...state, freehandPen: freehandPen(state.freehandPen, action) };
  }

  if (ReflowableContentUIAction.isDomesticAction(action)) {
    return {
      ...state,
      reflowableContentSetting: reflowableContentSetting(state.reflowableContentSetting, action),
    };
  }

  switch (action.type) {
    case UIAction.ActionType.SET_CURRENT_TOOL: {
      return { ...state, currentTool: action.currentTool };
    }
    case UIAction.ActionType.SET_MULTIROLE_LINK_STATE: {
      return { ...state, multiroleLink: action.state };
    }
    case UIAction.ActionType.SET_HANDERASING_WIDTH: {
      return { ...state, handerasing: { width: action.width } };
    }
    case UIAction.ActionType.SET_MARKER_SELECTED_COLOR_INDEX: {
      return { ...state, marker: { selectedColorIndex: action.index } };
    }
    case UIAction.ActionType.SET_LEARNING_PEN_WIDTH_INDEX: {
      return { ...state, learningPen: { widthIndex: action.widthIndex } };
    }
  }
};
